import { render, staticRenderFns } from "./dropbox.vue?vue&type=template&id=1dcc8f6a&"
import script from "./dropbox.vue?vue&type=script&lang=js&"
export * from "./dropbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports